const translationKeys = {
  bankswap_form_header_title: 'bankswap_form_header_title',
  bankswap_form_information_section_title:
    'bankswap_form_information_section_title',
  bankswap_form_start_button: 'bankswap_form_start_button',
  bankswap_form_requirement_dnbaccount_title:
    'bankswap_form_requirement_dnbaccount_title',
  bankswap_form_requirement_dnbaccount_message:
    'bankswap_form_requirement_dnbaccount_message',
  bankswap_form_requirement_otherbank_title:
    'bankswap_form_requirement_otherbank_title',
  bankswap_form_requirement_otherbank_message:
    'bankswap_form_requirement_otherbank_message',
  bankswap_form_requirement_bankid_title:
    'bankswap_form_requirement_bankid_title',
  bankswap_form_requirement_bankid_message:
    'bankswap_form_requirement_bankid_message',
  bankswap_form_info_move_for_other_title:
    'bankswap_form_info_move_for_other_title',
  bankswap_form_info_move_for_other_text:
    'bankswap_form_info_move_for_other_text',
  bankswap_form_step_bank_choice_title: 'bankswap_form_step_bank_choice_title',
  bankswap_form_step_accounts_title: 'bankswap_form_step_accounts_title',
  bankswap_form_step_summary_title: 'bankswap_form_step_summary_title',
  bankswap_form_section_bank_choice_title:
    'bankswap_form_section_bank_choice_title',
  bankswap_form_bank_selector_choose_bank_button:
    'bankswap_form_bank_selector_choose_bank_button',
  bankswap_form_bank_selector_selected_value_label:
    'bankswap_form_bank_selector_selected_value_label',
  bankswap_form_bank_selector_change_bank_button:
    'bankswap_form_bank_selector_change_bank_button',
  bankswap_form_bank_selector_bank_list_title:
    'bankswap_form_bank_selector_bank_list_title',
  bankswap_form_bank_selector_bank_list_chose_button:
    'bankswap_form_bank_selector_bank_list_chose_button',
  bankswap_form_section_bsu_title: 'bankswap_form_section_bsu_title',
  bankswap_form_section_deposits_and_payments_title:
    'bankswap_form_section_deposits_and_payments_title',
  bankswap_form_section_acounts_title: 'bankswap_form_section_acounts_title',
  bankswap_form_bsu_move_to_dnb_label: 'bankswap_form_bsu_move_to_dnb_label',
  bankswap_form_deposits_and_payments_forward_to_dnb_label:
    'bankswap_form_deposits_and_payments_forward_to_dnb_label',
  bankswap_form_accounts_from_label: 'bankswap_form_accounts_from_label',
  bankswap_form_accounts_to_label: 'bankswap_form_accounts_to_label',
  bankswap_form_accounts_authorization_label:
    'bankswap_form_accounts_authorization_label',
  bankswap_form_accounts_authorization_payment_orders_label:
    'bankswap_form_accounts_authorization_payment_orders_label',
  bankswap_form_accounts_authorization_payments_and_transfers_label:
    'bankswap_form_accounts_authorization_payments_and_transfers_label',
  bankswap_form_bsu_from_account_label: 'bankswap_form_bsu_from_account_label',
  bankswap_form_bsu_to_account_label: 'bankswap_form_bsu_to_account_label',
  bankswap_form_deposits_and_payments_deposits_account_label:
    'bankswap_form_deposits_and_payments_deposits_account_label',
  bankswap_form_deposits_and_payments_payments_account_label:
    'bankswap_form_deposits_and_payments_payments_account_label',
};

Object.freeze(translationKeys);

export default translationKeys;
